import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Link } from "react-router-dom";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('https://api.eyeonhealthwellness.com/api/auth/forgot-password', { email });
      toast.success('Password reset email sent');
    } catch (error) {
      toast.error('Error sending reset email');
    }
  };

  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      {/* --- Left Side --- */}
      <div className="hidden md:flex md:w-1/2 bg-[#1e5782] text-white items-center justify-center flex-col p-10">
        <h1 className="text-3xl font-semibold mb-4 text-center leading-snug">
          Recover Access to Your Eye on Health <br /> We all forget our password some days.
        </h1>
        <p className="text-gray-200 text-center max-w-md text-sm leading-relaxed">
          Don’t worry — even the sharpest eyes need a little help sometimes.  
          Reset your password and get back to improving eye wellness today.
        </p>
        <div className="mt-8 w-16 h-[2px] bg-white/30 rounded-full"></div>
      </div>

      {/* --- Right Side (Form) --- */}
      <div className="w-full md:w-1/2 flex items-center justify-center bg-white px-8 py-12">
        <div className="w-full max-w-md">
          {/* Logo for mobile */}
          <div className="md:hidden flex justify-center mb-8">
            <img
              src="/assets/logo.png"
              alt="Company Logo"
              className="w-36 h-12 object-contain"
            />
          </div>

          <h2 className="text-2xl font-semibold text-gray-900 mb-6 text-center">
            Reset your password
          </h2>

          <form
            onSubmit={handleSubmit}
            className="bg-white space-y-6 border border-gray-200/60 rounded-xl p-8 shadow-sm"
          >
            <div>
              <label
                htmlFor="email"
                className="block text-sm text-gray-700 mb-1 font-medium"
              >
                Email Address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                placeholder="your-email@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="
                  block w-full 
                  rounded-lg 
                  border border-gray-200 
                  focus:border-gray-400 
                  focus:ring-0 
                  text-sm 
                  px-3 py-2.5 
                  text-gray-900 
                  placeholder-gray-400 
                  bg-white 
                  transition-all 
                  duration-150 
                  hover:border-gray-300
                "
              />
            </div>

            <button
              type="submit"
              className="w-full bg-[#1e5782] text-white font-medium py-2.5 rounded-lg hover:bg-[#184766] transition-colors duration-200"
            >
              Send Reset Link
            </button>

            <div className="text-center">
              <Link
                to="/login"
                className="text-[#1e5782] font-medium hover:underline text-sm"
              >
                Back to login
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
